module.exports = __webpack_public_path__ + "img/Frame 5109.94a53019.jpg";